<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="templeShowDialog"
    width="1000px"
    style="height:500px,max-height:500px"
    center
    :append-to-body="true"
    @closed="closeDialog"
    v-drag
  >
    <div class="page">
      <div class="title">{{ getSecond() }}</div>
      <sirui-search
        ref="conditionRef"
        :query="params.spaceDTO"
        :isQueryPanel="false"
        :columns="formColumn"
        :rules="baseRules"
        labelWidth="130px"
        @changeCondition="changeCondition"
      ></sirui-search>
      <FileTable ref="fileTableRef" :attachments="storageAttachment" />
      <div v-if="this.params.spaceDTO != null && this.params.spaceDTO.leafFlag == '0'">
        <div class="title">能耗表</div>
        <el-row style="margin-top: 10px; margin-left: 15px; margin-bottom: 15px">
          <el-button type="primary" @click="addTable('electricity')" class="fixed-bottom-btn"
            >新增电表</el-button
          >
          <el-button type="primary" @click="addTable('water')" class="fixed-bottom-btn"
            >新增水表</el-button
          >
          <el-button type="primary" @click="deleteTable" class="delete">删除</el-button>
        </el-row>
        <vxe-table
          ref="energyTable"
          :data="this.params.energyDTOList"
          border
          align="center"
          header-align="center"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column field="energyTypeName" title="水表/电表"></vxe-table-column>
          <vxe-table-column field="energyCode" title="编号"></vxe-table-column>
          <vxe-table-column field="energyMeterTypeName" title="能耗表类型"></vxe-table-column>
        </vxe-table>
      </div>
      <div class="bottom">
        <el-button type="primary" @click="closeDialog" class="btn-cancer">取消</el-button>
        <el-button type="primary" @click="add" :loading="load" class="btn-save">保存</el-button>
        <el-button
          type="primary"
          v-if="appendType == '05'"
          @click="continueAdd"
          :loading="load"
          class="btn-save"
          >继续添加</el-button
        >
      </div>
      <QueryTableDialog
        :showDialog="showQueryTableDialog"
        v-if="showQueryTableDialog"
        :chooseType="chooseType"
        :companyCode="personCompanyCode"
        @chooseData="chooseData($event)"
        :chooseEnergyIds="chooseEnergyIds"
        @closeDialog="showQueryTableDialog = false"
      >
      </QueryTableDialog>
    </div>
  </el-dialog>
</template>
<script>
  import QueryTableDialog from './queryTableDialog.vue';
  import SiruiSearch from '@/components/SiruiSearch';
  import propertyMixin from '../mixins/propertyMixin';
  import { generalFormItem } from '@/api/property/model';
  import { baseRules } from '../rules/rules'; // 校验规则
  import API from '@/api/property/spaceAssets';
  import '@/utils/directives.js';
  export default {
    name: 'AddPropertyDialog',
    mixins: [propertyMixin],

    components: {
      QueryTableDialog,
      SiruiSearch,
    },
    computed: {
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 8 : 14;
      },
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      personCompanyCode: {
        type: String,
        default: '',
      },
      companyList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      parentId: {
        type: String,
        default: '',
      },
      appendType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        labelWidth: '120px',
        baseRules: baseRules,
        load: false,
        tableData: [],
        storageAttachment: [],
        // fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg', 'png'],
        templeShowDialog: this.showDialog,
        showQueryTableDialog: false,
        chooseEnergyIds: [],
        chooseType: '',
        params: JSON.parse(JSON.stringify(generalFormItem)),
      };
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
      'query.location2': {
        handler: function (newVal) {
          if (newVal == '1') {
            console.log(newVal);
          }
        },
        deep: true,
      },
    },
    mounted() {
      this.params = JSON.parse(JSON.stringify(generalFormItem));
      if (this.appendType == '05') {
        this.params.spaceDTO.leafFlag = '0';
      }
      this.resetCondition();
    },

    methods: {
      closeDialog() {
        this.load = false;
        this.$emit('closeDialog', false);
      },
      //继续添加
      continueAdd() {
        this.$refs.conditionRef.validate((value, data) => {
          console.log(value, data);
          if (!value) {
            return;
          }
          this.load = true;
          var list = this.companyList.filter(
            (item) => item.personCompanyCode == this.personCompanyCode
          );
          this.params.spaceDTO.spaceCompanyNo = list[0].personCompanyCode;
          this.params.spaceDTO.spaceCompanyName = list[0].personCompanyName;
          this.params.spaceDTO.type = this.appendType;
          this.params.spaceDTO.assetType = this.params.spaceDTO.tempAssetType.join(',');
          this.params.spaceDTO.parentId = parseInt(this.parentId);
          if (this.$refs.fileTableRef.getTableData().length > 0) {
            this.params.spaceDTO.attachments = this.$refs.fileTableRef.getTableData();
          }
          this.$axios.post(API.SAVE, this.params).then((res) => {
            if (res.data.code == '0') {
              this.$emit('refreshTree', true);
              this.params = JSON.parse(JSON.stringify(generalFormItem));
              if (this.appendType == '05') {
                this.params.spaceDTO.leafFlag = '0';
              }
              this.$refs.fileTableRef.tableData = [];
              this.$message.success('添加成功');
            } else {
              this.$message.error(res.data.msg);
            }
            this.load = false;
          });
        });
      },
      uploadHandler(fileObj) {
        this.tableData.push({
          attachmentName: fileObj.attachmentName,
          createBy: fileObj.createBy,
          gmtCreate: new Date(),
          attachmentKey: fileObj.attachmentKey,
          attachmentPath: fileObj.attachmentPath,
        });
      },
      add() {
        this.$refs.conditionRef.validate((value, data) => {
          console.log(value, data);
          if (!value) {
            return;
          }
          this.load = true;
          var list = this.companyList.filter(
            (item) => item.personCompanyCode == this.personCompanyCode
          );
          this.params.spaceDTO.spaceCompanyNo = list[0].personCompanyCode;
          this.params.spaceDTO.spaceCompanyName = list[0].personCompanyName;
          this.params.spaceDTO.type = this.appendType;
          this.params.spaceDTO.assetType = this.params.spaceDTO.tempAssetType.join(',');
          this.params.spaceDTO.parentId = parseInt(this.parentId);
          if (this.$refs.fileTableRef.getTableData().length > 0) {
            this.params.spaceDTO.attachments = this.$refs.fileTableRef.getTableData();
          }
          this.$axios.post(API.SAVE, this.params).then((res) => {
            if (res.data.code == '0') {
              this.$message.success('保存成功');
              this.$emit('refreshTree', true);
              this.closeDialog();
            } else {
              this.$message.error(res.data.msg);
            }
            this.load = false;
          });
        });
      },

      //新增电表/水表
      addTable(var1) {
        console.log('addTable', var1);
        this.chooseType = var1;
        this.chooseEnergyIds = this.params.energyDTOList.map((item) => item.energyId);
        this.showQueryTableDialog = true;
      },
      deleteTable() {
        let selectRecords = this.$refs.energyTable.getCheckboxRecords();
        let chooseList = selectRecords.map((item) => item.energyId);
        this.params.energyDTOList = this.params.energyDTOList.filter(
          (item) => !chooseList.includes(item.energyId)
        );
      },
      changeMethod(val, relatedColumn, method, prop) {
        console.log('changeMethod', val, relatedColumn, method, prop, this.query);
        if (!method) {
          return;
        }
        if (relatedColumn) {
          this.query[relatedColumn] = null;
        }
      },
      clearMethod(val, method) {
        console.log('clearMethod', val, method, this.query);
        if (!method) {
          return;
        }
      },
      getTitle() {
        let arr = { '02': '新增资产', '03': '新增单元', '04': '新增楼层', '05': '新增房间' };
        return arr[this.appendType];
      },
      getSecond() {
        let arr = {
          '02': '资产信息',
          '03': '单元（楼栋）信息',
          '04': '楼层信息',
          '05': '房间信息',
        };
        return arr[this.appendType];
      },
      chooseData(data) {
        let chooseEnergyIds3 = data.map((item) => item.energyId);
        let tempList = this.params.energyDTOList.filter(
          (item) => chooseEnergyIds3.includes(item.energyId) || item.energyType != this.parseType()
        );
        let chooseEnergyIds2 = this.params.energyDTOList.map((item) => item.energyId);
        let tempAddList = data.filter((item) => {
          let value = chooseEnergyIds2.includes(item.energyId);
          return !value;
        });
        this.params.energyDTOList = [...tempList, ...tempAddList];
      },
      parseType() {
        return this.chooseType == 'electricity' ? '02' : '01';
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    overflow: scroll;
    overflow-y: scroll;
    height: calc(100vh - 330px);
  }
  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }
  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .delete {
    padding: 0px 0px;
    background-color: #ff3400;
    color: white;
    min-width: 50px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .bottom {
    margin-top: 20px;
    margin-bottom: 0px;
    text-align: center;
    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      border: 0px solid #dcdfe6;
    }
    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }
  ::v-deep .el-form-item__label {
    font-size: 12px;
  }
</style>
